import { createAction } from '@reduxjs/toolkit';

export const requestViewPersonContracts = createAction('contract/viewPersonContracts');
export const requestViewContract = createAction('contract/viewContract');
export const requestExpressInterest = createAction('contract/expressInterest');
export const requestAmendContract = createAction('contract/amendContract');
export const requestUpdateContractStatus = createAction('contract/updateContractStatus');
export const requestCancelContract = createAction('contract/cancelContract');
export const requestRetrieveChatForDeal = createAction('contract/retrieveChatForDeal');
export const requestCreateMessageForDeal = createAction('contract/createMessageForDeal');
export const requestViewAdminContracts = createAction('contract/viewAdminContracts');
export const requestReviewDocument = createAction('contract/reviewDocument');
export const requestRequestAssistance = createAction('contract/requestAssistance');
